import cn from 'classnames';
import AnimateHeight from 'react-animate-height';
import ErrorMessage from 'components/ErrorMessage/index.js';
import IconExclamation from 'static/icons/exclamation.svg';
import './index.scss';

const Input = ({
    label,
    type,
    name,
    errors,
    warnings,
    className,
    maxLength,
    inputClassName = '',
    multiple,
    options,
    max,
    ...rest
}) => {
    const hasError = !!errors?.[name]?.length;
    const hasOptions = !!options?.length;
    const idDatalist = hasOptions ? `${name || 'input'}-datalist` : undefined;
    const hasWarning = !!warnings?.[name]?.length;

    return (
        <label className={cn('form-label', className)}>
            <span className='form-label-text'>{label}</span>
            <div className='form-field'>
                <input
                    type={type || 'text'}
                    name={name}
                    maxLength={maxLength || 100}
                    max={max || (type === 'number' ? 2147483647 : max)}
                    className={`form-field-input ${inputClassName} ${hasError ? 'invalid' : ''}`}
                    list={idDatalist}
                    {...rest}
                />
                {hasOptions && (
                    <datalist id={idDatalist}>
                        {options.map(option => <option key={option} value={option}>{option}</option>)}
                    </datalist>
                )}
            </div>
            <AnimateHeight animateOpacity duration={200} height={hasError ? 'auto' : 0}>
                <ErrorMessage className={`form-error ${hasError ? 'has-error' : ''}`}>
                    {errors?.[name] || ''}
                </ErrorMessage>
            </AnimateHeight>
            <AnimateHeight animateOpacity duration={200} height={hasWarning ? 'auto' : 0}>
                <ErrorMessage className={`form-warning ${hasWarning ? 'has-warning' : ''}`}>
                    <IconExclamation /> {warnings?.[name] || ''}
                </ErrorMessage>
            </AnimateHeight>
        </label>
    );
};

export default Input;
